import Vue from "vue";
import VueRouter from 'vue-router'
Vue.use(VueRouter);
import ProjectRouter from '@/project/router.js'
import StorageConfig from "@/services/config/StorageConfig";
import { Helper } from "@/core/helper";

const routes = [
  {
    path: "/",
    component: () => import("@/app/App.vue"),
    children: [ProjectRouter],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
  },
  routes,
});

router.beforeEach((to, from, next) => {
  // Set the page title to "Valiant"
  document.title = 'Valiant';

  const reqLogout = to.matched.some(record => record.meta.reqLogout);
  const reqAuth = to.matched.some(record => record.meta.reqAuth);
  const reqPermission = to.meta.reqPermission;
  const haveToken = !!StorageConfig.getToken();

  if (reqAuth && !haveToken) {
    // If the route requires authentication and the user is not logged in, redirect to login
    next('/landing');
  } else if (reqLogout && haveToken) {
    // If the route requires logout but the user is logged in, redirect to dashboard
    next('/peta-views');
  } else if (to.path === '/login' && haveToken) {
    // Explicitly prevent accessing the login page if the user is already logged in
    next('/peta-views');
  } else if (reqAuth) {
    if (reqPermission) {
      console.log(reqPermission)
      if (Helper.hasPermission(reqPermission)) {
        next()
      } else {
        next('/401');
      }
    } else {
      next();
    }
  }
  else {
    // Proceed to the route if none of the above conditions are met
    next();
  }
});

export default router;